import {durationUnits} from 'utilities/helper/durationUnitsOption';

export const initialValues = (
  farm: IFarmAddInfo | undefined,
  productDetail?: IGetPostDetail,
  postEditDetail?: IPostEditDetail,
) => {
  return {
    price: String(productDetail?.price) || '',
    duration: String(postEditDetail?.duration) || '',
    duration_unit:
      postEditDetail?.duration_unit || durationUnits[0].value?.toString(),
    area: farm?.area,

    financial_type: 'cash',
  };
};
